/**
 * @Author: wuyang
 * @Date: 2024/2/1
 * @Description: ""
 */

import { requestInstance } from './instance'

/**
 * 获取会员列表
 */
export const getVipListCode = () => {
	return requestInstance
		.get<any, any>('/tariff-package/package/list', {})
		.fire()
}

/**
 * 获取套餐里面的付费列表
 * @param packageId
 */
export const getPayListByVipPackage = (packageId: string) => {
	return requestInstance
		.get<
			any,
			{
				data: Array<{
					tariffPackageSubName: string
					tariffPackageSubId: string
					score: number
					cycle: number
					subMoney: number
					parentId: string
				}>
				total: number
			}
		>('/tariff-package/package/front/subList', {
			parentId: packageId,
			pageNum: 1,
			pageSize: 1000
		})
		.fire()
}

/**
 * 获取算力包里面的付费列表
 */
export const getPayListByRefueling = () => {
	return requestInstance
		.get<
			any,
			{
				data: Array<{
					refuelingBagName: string
					refuelingBagId: string
					score: number
					cycle: number
					money: number
				}>
				total: number
			}
		>('/refueling/bag/front/queryList', {
			pageNum: 1,
			pageSize: 1000
		})
		.fire()
}

/**
 * 判断套餐接口里是否可以升级使用
 */
export const canUpdatePackage = (params: {
	packageId: string
	subId: string
	type: number
}) => {
	return requestInstance
		.get<
			any,
			{
				money: number
				update: number
				codeUrl: string
			}
		>('/tariff-package/package/canUpdatePackage', params)
		.fire()
}

/**
 * 升级套餐使用
 */
export const updatePackage = (params: { packageId: string; subId: string }) => {
	return requestInstance
		.get<any, any>('/tariff-package/package/updatePackage', params)
		.fire()
}

/**
 * 获取订单列表
 */
export const getOrderList = (params: { pageNum: number; pageSize: number }) => {
	return requestInstance
		.get<
			any,
			{
				total: number
				data: {
					createTime: string
					duration: number
					money: number
					orderId: string
					orderNo: string
					productName: string
					productEndTime: string
					type: number
					status: number
					title: string
					updateTime: string
				}[]
			}
		>('/pay/order/front/my/list', params)
		.fire()
}

/* 获取微信/支付宝支付方式 */
export const createOrder = (data: any) => {
	return requestInstance
		.post('/api/package-payment/create-order', data)
		.fire()
}